import { atom } from 'recoil';

export const selectedCurrencyState = atom({
  key: 'selectedCurrencyAtom',
  default: 'EUR', // Default to EUR
});